import React from "react";
import { Grid, Section, Typography, Divider } from "../../core";
import { MixStyle, media, theme } from "../../styles";
import EditFaricContract from "../../components/EditFabricContract";
import styled from "styled-components";

const { colors } = theme;
const Container = styled.div`
  margin: 50px 0px;
`;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
`;
const EditFabricContract = () => {
  return (
    <Container>
      <Grid>
        <Section padding="10px 50px">
          <TittleWraper>
            <Typography
              className="d-inline--block"
              align="center"
              as="h1"
              color={colors.darkPink}
              weight="bold"
            >
              Edit Fabric Contract
              <Divider />
            </Typography>
          </TittleWraper>
          <EditFaricContract />
        </Section>
      </Grid>
    </Container>
  );
};

export default EditFabricContract;
